module.exports = __webpack_public_path__ + "img/cert15x.4c507a54.png";